import React from 'react';

import PageTitle from '../../Components/PageTitle';
import  images  from '../../assets/images/verticless.jpg';

function Verticals() {
    return (
        <>
            <PageTitle title="Verticals" />
                <section className="second-level-section">
                    <div className="container">
                        <div className="row">
                            <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                                <div className="left-box tick-icon-list text-center">
                                    <h1>Software  <span>Engineering, Consulting & </span> Outsourcing</h1>
                                    <h2>Since 2004, Globally Trusted Indian Software Services Company</h2>
                                        <p>We are an award-winning Indian software engineering services company focused on providing software consulting, outsourced software development, digital 
                                        transformation and software engineering teams to our clients globally. With a 97% customer satisfaction rate, we are consistently recognized as one of the top </p>
                                </div>
                            </div>
                            <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                                <div className='vertis_set'>
                                    <div className='row'>
                                        <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className="left-box tick-icon-list">
                                                <h1>Software Development &  <span>Engineering Services </span></h1>
                                                <p>We deliver robust, scalable, and reliable software product solutions to clients across the globe driven by the top 1% of software engineering talent in India  </p>
                                                <div className='vertils_img'>
                                                    <img src={images} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='feature'>
                                                <h2>
                                                    Smart Teams
                                                </h2>
                                                <p>
                                                    You can extend or build a new software development team ground up with top-notch software development experts from ValueCoders! We offer dedicated experts for front-end, back-end, UI/UX.....
                                                </p>

                                            </div>
                                            <div className='feature'>
                                                <h2>
                                                    Software Engineering
                                                </h2>
                                                <p>
                                                    We offer end-to-end software outsourcing services from initial consulting to development & deployment. Our expertise helps businesses launch new products faster, modernize existing....
                                                </p>

                                            </div>
                                            <div className='feature'>
                                                <h2>
                                                    Smart Automation
                                                </h2>
                                                <p>
                                                    You can save invaluable human resources, accelerate your business and maximize throughput with our smart automation services. We leverage cutting edge technologies like BlockChain, RPA, Machine Learning and Chatbots to....
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
        </>
    );
}

export default Verticals;
